import { render } from "./CustomerReportPage.vue?vue&type=template&id=211a3b80&scoped=true&ts=true"
import script from "./CustomerReportPage.vue?vue&type=script&lang=ts"
export * from "./CustomerReportPage.vue?vue&type=script&lang=ts"

import "./CustomerReportPage.vue?vue&type=style&index=0&id=211a3b80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211a3b80"]])

export default __exports__